<template>
  <div style="width: 100%; height: 240px;">
    <VueApexCharts
      :key="JSON.stringify(chartSeries)"
      type="bar"
      height="240px"
      :options="chartOptions"
      :series="chartSeries"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import VueApexCharts from 'vue3-apexcharts';

const props = defineProps({
  chartData: {
    type: Object,
    required: true
  }
});

const traitPairs = [
  ['E', 'I'],
  ['S', 'N'],
  ['T', 'F'],
  ['J', 'P']
];

const colors = {
  E: '#FF6867',
  I: '#4eaeea',
  S: '#7d67fd',
  N: '#adcc32',
  T: '#27b190',
  F: '#E53C9C',
  J: '#4881ce',
  P: '#ffb401'
};

const leftSeriesData = [];
const rightSeriesData = [];

traitPairs.forEach(([left, right]) => {
  const leftValue = props.chartData[left] ?? 0;
  const rightValue = props.chartData[right] ?? 0;

  const isLeftActive = leftValue >= rightValue;

  leftSeriesData.push({
    x: left,
    y: isLeftActive ? leftValue : 100 - rightValue,
    fillColor: isLeftActive ? colors[left] : '#E5E5E5',
    // TODO: 막대  색상 별 데이터라벨 텍스트 컬러 다르게
    // dataLabelColor: isLeftActive ? '#fff' : '#757575'
    dataLabelColor: '#757575'
  });

  rightSeriesData.push({
    x: right,
    y: -(isLeftActive ? 100 - leftValue : rightValue),
    fillColor: isLeftActive ? '#E5E5E5' : colors[right],
    // TODO: 막대  색상 별 데이터라벨 텍스트 컬러 다르게
    // dataLabelColor: isLeftActive ? '#757575' : '#fff'
    dataLabelColor: '#757575'
  });
});

const chartSeries = computed(() => [
  { name: '왼쪽', data: leftSeriesData },
  { name: '오른쪽', data: rightSeriesData }
]);

const chartOptions = computed(() => ({
  chart: {
    type: 'bar',
    stacked: true,
    toolbar: { show: false }
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '40%',
      borderRadius: 6,
      borderRadiusWhenStacked: 'all'
    }
  },
  xaxis: {
    position: 'top',
    offsetY: -10,
    min: -100,
    max: 100,
    tickAmount: 8,
    labels: {
      formatter: val => Math.abs(val).toString()
    },
    axisBorder: {
      show: false
    },
    axisTicks: {
      show: false
    }
  },
  yaxis: {
    categories: traitPairs.map(([left, right]) => `${left}/${right}`),
    labels: { show: false }
  },
  dataLabels: {
    enabled: true,
    formatter: (_val, opts) =>
      opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x,
    style: {
      fontSize: '14px',
      fontWeight: 700,
      colors: chartSeries.value.flatMap(series =>
        series.data.map(d => d.dataLabelColor)
      )
    },
    background: { enabled: false }
  },
  fill: {
    colors: chartSeries.value.flatMap(series =>
      series.data.map(d => d.fillColor)
    )
  },
  tooltip: {
    custom: ({ seriesIndex, dataPointIndex, w }) => {
      const item = w.config.series[seriesIndex].data[dataPointIndex];
      return `
        <div style="
          background: #000;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
        ">
          ${item.x}: ${Math.abs(item.y).toFixed(1)}%
        </div>`;
    }
  },
  legend: { show: false },
  grid: {
    xaxis: { lines: { show: true } },
    yaxis: { lines: { show: false } },
    strokeDashArray: 4,
  }
}));
</script>

<style scoped>
.mbti-tooltip {
  background: #000;
  color: white;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
}
</style>
